(function () {
  'use strict';

  var SLICK_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css';
  var SLICK_JS  = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
  var JQUERY_JS = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';

  var DESKTOP_ITEMS = 4;

  function injectOnce(tag, attrs, cb) {
    var key = attrs.src || attrs.href;
    if (key && document.querySelector('[src="' + key + '"],[href="' + key + '"]')) {
      if (cb) cb();
      return;
    }
    var el = document.createElement(tag);
    Object.keys(attrs).forEach(function (k) { el[k] = attrs[k]; });
    if (cb) el.onload = cb;
    document.head.appendChild(el);
  }

  function getConfig(wrapper) {
    return {
      autoplaySpeed : parseInt(wrapper.dataset.autoplaySpeed, 10) || 2000,
      transitionMs  : parseInt(wrapper.dataset.transitionMs,  10) || 600
    };
  }

  function ensureSlides(sliderEl, needed) {
    var originals = Array.prototype.slice.call(
      sliderEl.querySelectorAll('.heaven-trust-bar__item:not([data-cloned])')
    );
    if (!originals.length) return;
    var i = 0;
    while (sliderEl.querySelectorAll('.heaven-trust-bar__item').length < needed) {
      var clone = originals[i % originals.length].cloneNode(true);
      clone.setAttribute('data-cloned', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.removeAttribute('id');
      sliderEl.appendChild(clone);
      i++;
    }
  }

  function initSlider(wrapper) {
    var jq = window.jQuery;
    if (!jq || !jq.fn.slick) return;

    var cfg    = getConfig(wrapper);
    var slider = jq(wrapper).find('.heaven-trust-bar__slider');
    if (!slider.length) return;

    if (slider.hasClass('slick-initialized')) slider.slick('unslick');

    ensureSlides(slider[0], DESKTOP_ITEMS * 3);

    slider.slick({
      slidesToShow   : DESKTOP_ITEMS,   /* ≥ 1025px → 4 */
      slidesToScroll : 1,
      autoplay       : true,
      autoplaySpeed  : cfg.autoplaySpeed,
      speed          : cfg.transitionMs,
      cssEase        : 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      infinite       : true,
      dots           : false,
      arrows         : false,
      pauseOnHover   : false,
      pauseOnFocus   : false,
      swipe          : true,
      touchThreshold : 10,
      responsive     : [
        {
          breakpoint : 1024,   /* 993px – 1024px → 3 */
          settings   : { slidesToShow: 3, slidesToScroll: 1 }
        },
        {
          breakpoint : 992,    /* 769px – 992px  → 2 */
          settings   : { slidesToShow: 2, slidesToScroll: 1 }
        },
        {
          breakpoint : 768,    /* ≤ 768px         → 1 */
          settings   : { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });
  }

  function initAll() {
    document.querySelectorAll('.heaven-trust-bar').forEach(initSlider);
  }

  function loadSlickThenInit() {
    injectOnce('link', { rel: 'stylesheet', href: SLICK_CSS });

    function onSlickReady() { initAll(); }

    function loadSlickJS() {
      if (window.jQuery && window.jQuery.fn.slick) { onSlickReady(); return; }
      injectOnce('script', { src: SLICK_JS }, onSlickReady);
    }

    if (window.jQuery) {
      loadSlickJS();
    } else {
      injectOnce('script', { src: JQUERY_JS }, loadSlickJS);
    }
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadSlickThenInit, { timeout: 2000 });
    } else {
      setTimeout(loadSlickThenInit, 200);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var wrapper = evt.target && evt.target.querySelector('.heaven-trust-bar');
    if (!wrapper) return;
    if (window.jQuery && window.jQuery.fn.slick) {
      initSlider(wrapper);
    } else {
      schedule();
    }
  });

}());